import React from "react";
import {useTranslation} from "react-i18next";

import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { Warning } from "@vedmarket/ui-kit";

import SupportAccordionCard from "../accordion-card";
import {COLORS} from "../../../../../config/constants";

import './support-guidelines.scss'

const SupportGuidelines = () => {

  const { t } = useTranslation();

  return (
    <section className='support-guidelines'>
      <SupportAccordionCard
        title={t('support__text__important')}
        icon={<Warning />}
        iconVariant='warning'
      >
        <Typography
          component='ol'
          variant='body1'
          className='support-guidelines__list'
          sx={{
            color: COLORS.BLACK_DARK,
            letterSpacing: 0,
            lineHeight: '28px',
            margin: 0,
            paddingBottom: '8px',
            paddingLeft: '24px',
          }}
        >
          <li className='support-guidelines__list-item'>
            {t('support__text__scheduleStart')}
            {' '}
            <strong className='support-guidelines__bold-text'>{t('support__text__scheduleBold')}</strong>
            {' '}
            {t('support__text__scheduleEnd')}
            .
          </li>
          <li className='support-guidelines__list-item'>
            {t('support__text__responseTimeStart')}
            {' '}
            <strong className='support-guidelines__bold-text'>{t('support__text__responseTimeBold')}</strong>
            .
          </li>
          <li className='support-guidelines__list-item'>
            {t('support__text__helpCenterStart')}
            {' '}
            <Link
              href='https://help.vedmarket.ru/'
              rel='noreferrer'
              target='_blank'
              underline='always'
              sx={{color: COLORS.BLUE, cursor: 'pointer'}}
            >
              {t('support__text__helpCenter')}
            </Link>
            .
          </li>
        </Typography>
      </SupportAccordionCard>
    </section>
  );
};

export default SupportGuidelines;
